import { useEffect, useMemo, useState } from "react";
import { fetchPosCatalog } from "../../services/pos";
 
export type Modifier = { id:number; name:string; price_delta:number|string };
export type ModifierGroup = { id:number; name:string; required?:boolean; min_select?:number|null; max_select?:number|null; modifiers?:Modifier[] };
const getImageUrl = (v?: string | null) => {
  const publicStorageURI = process.env.PUBLIC_STORAGE_URI || 'https://app.itable.app/api'
  if (!v) return undefined;
  if (v.startsWith("http")) return v;
  return `${publicStorageURI.replace("/api", "")}/storage/${v}`;
};

export function useCatalogGrouped(isLoggedIn:boolean, activeCat:number|null|undefined) {
  const [catalog, setCatalog] = useState<Array<{category:any; products:any[]}>>([]);
  useEffect(()=> {
    if (!isLoggedIn || !localStorage.getItem("device_token")) return;
    (async()=>{
      try {
        const data = await fetchPosCatalog();
        setCatalog(Array.isArray(data) ? data : []);
      } catch { setCatalog([]); }
    })();
  }, [isLoggedIn]);

  const categories = useMemo(()=> catalog.map(row => row.category), [catalog]);
  const products   = useMemo(()=>{
    if (!activeCat) return [];
    //foreach image in product get getImageUrl(product.image)
    catalog.forEach(entry => {
      entry.products.forEach(product => {
        product.image = getImageUrl(product.image || null);
      });
    });
    const entry = catalog.find(c => c.category?.id === activeCat);
    return entry?.products || [];
  }, [catalog, activeCat]);

  return { categories, products };
}
